export class MenuEpc {
    public presetMenu: any[] = [
        { label: 'Página Inicial', icon: 'home', routerLink: ['sistema/modulos'] },
        {
            label: 'Capacitadora', icon: 'dashboard', items: [
                { label: 'Gerenciamento', icon: 'laptop_chromebook', routerLink: ['capacitadora/gerenciamento-capacitadora'] },
                { label: 'Homologação', icon: 'chat_bubble', routerLink: ['capacitadora/homologacao-capacitadora'] }
            ]
        },
        {
            label: 'Minhas Atividades', icon: 'dashboard', items: [
                { label: 'Curso', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-curso'] },
                { label: 'Evento', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-evento'] },
                { label: 'Curso Prestação de Contas', icon: 'account_balance', routerLink: ['atividades/curso-prestacao-conta'] },
                { label: 'Docência e Orientação', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-docencia'] },
                { label: 'Participação em Bancas', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-banca'] },
                { label: 'Comissão', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-comissao'] },
                { label: 'Curso Exterior', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-curso-exterior'] },
                { label: 'Produção Intelectual', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-producao-intelectual'] },
                { label: 'Pós, Grad. e Extensão', icon: 'playlist_add_check', routerLink: ['atividades/gerenciamento-pos-graduacao'] },
            ]
        },
        {
            label: 'Homologação', icon: 'dashboard', items: [
                { label: 'Curso', icon: 'filter', routerLink: ['atividades/homologacao-curso'] },
                { label: 'Evento', icon: 'filter', routerLink: ['atividades/homologacao-evento'] },
                { label: 'Docência e Orientação', icon: 'filter', routerLink: ['atividades/homologacao-docencia'] },
                { label: 'Participação em Bancas', icon: 'filter', routerLink: ['atividades/homologacao-banca'] },
                { label: 'Comissão', icon: 'filter', routerLink: ['atividades/homologacao-comissao'] },
                { label: 'Curso Exterior', icon: 'filter', routerLink: ['atividades/homologacao-curso-exterior'] },
                { label: 'Produção Intelectual ', icon: 'filter', routerLink: ['atividades/homologacao-producao-intelectual'] },
                { label: 'Pós, Grad. e Extensão', icon: 'filter', routerLink: ['atividades/homologacao-pos-graduacao'] },
                { label: 'Câmara-Plenária', icon: 'class', routerLink: ['atividades/homologacao-camara-plenaria'] },
            ]
        },
        // {
        //     label: 'Ausências Justificáveis', icon: 'dashboard', items: [
        //         { label: 'Minhas Justificativas', icon: 'assignment', routerLink: ['justificativas/gerenciamento-justificativa'] }
        //     ]
        // },
        {
            label: 'Cadastro', icon: 'dashboard', items: [
                { label: 'Abrangência', icon: 'group_add', routerLink: ['cadastro/abrangencia'] },
                { label: 'Área', icon: 'event_available', routerLink: ['cadastro/area'] },
                { label: 'Área Temática', icon: 'import_contacts', routerLink: ['cadastro/area-tematica'] },
                { label: 'Critério de Avaliação', icon: 'event_available', routerLink: ['cadastro/criterio-avaliacao'] },
                { label: 'Formação Acadêmica', icon: 'event_available', routerLink: ['cadastro/formacao-academica'] },
                { label: 'Instituição', icon: 'event_available', routerLink: ['cadastro/instituicao'] },
                { label: 'Instrutor', icon: 'event_available', routerLink: ['cadastro/instrutor'] },
                { label: 'Modalidade', icon: 'tune', routerLink: ['cadastro/modalidade'] },
                { label: 'Público Alvo', icon: 'business_center', routerLink: ['cadastro/publico-alvo'] },
            ]
        },
        {
            label: 'Parametrização', icon: 'dashboard', items: [
                { label: 'Natureza', icon: 'filter_1', routerLink: ['parametrizacao/parametrizacao-natureza'] },
                { label: 'Norma', icon: 'filter_1', routerLink: ['parametrizacao/norma'] },
                { label: 'Pontuação', icon: 'tune', routerLink: ['parametrizacao/parametrizacao-pontuacao'] },
                { label: 'Par. de Grupos de Ativ.', icon: 'event_available', routerLink: ['parametrizacao/regra-pt-grupo-atividade'] },
                { label: 'Prestação de Contas', icon: 'schedule', routerLink: ['parametrizacao/prazo-prestacao-conta'] }
            ]
        },
        {
            label: 'Configurações', icon: 'dashboard', items: [
                { label: 'Ger. de Autonomia', icon: 'account_balance', routerLink: ['configuracao/gerenciamento-autonomia'] },
            ]
        },
        {
            label: 'Prestação de Contas', icon: 'dashboard', items: [
                { label: 'Rel. Atividades', icon: 'account_balance', routerLink: ['prestacao/prestacao-conta'] },
                { label: 'Rel. Profissionais', icon: 'account_balance', routerLink: ['prestacao/prestacao-contas-gestor'] },
                { label: 'Rel. Profissionais 2017', icon: 'account_balance', routerLink: ['prestacao-conta-2017/prestacao-conta'] },
                { label: 'Rel. Atividades Físico', icon: 'account_balance', routerLink: ['prestacao/atividade-unificado'] }
            ]
        },
        {
                label: 'Relatório Gerencial', icon: 'dashboard', items: [
                { label: 'Rel. Prestação Conta', icon: 'account_balance', routerLink: ['relatorio/relatorio-epc'] },
                { label: 'Rel. Atividades Julgadas', icon: 'account_balance', routerLink: ['relatorio/relatorio-atividades-julgadas'] },
                { label: 'Rel. Atividades por Atas', icon: 'account_balance', routerLink: ['relatorio/relatorio-atividades-atas'] },
                { label: 'Rel. Prof. CNAI e CNPC', icon: 'account_balance', routerLink: ['relatorio/relatorio-profissionais-cnai-cnpc'] },

                { label: 'Rel. Part. por Curso', icon: 'account_balance', routerLink: ['relatorio/relatorio-profissionais-por-curso'] },
                { label: 'Rel. Turma por Curso', icon: 'account_balance', routerLink: ['relatorio/relatorio-turma-cadastrada-por-curso'] },
                { label: 'Rel. Curso por Capac.', icon: 'account_balance', routerLink: ['relatorio/relatorio-curso-credenciado-por-capacitadora'] },
                { label: 'Rel. Part. por Evento', icon: 'account_balance', routerLink: ['relatorio/relatorio-profissionais-por-evento'] },
                { label: 'Rel. Evento por Cap.', icon: 'account_balance', routerLink: ['relatorio/relatorio-evento-credenciado-por-capacitadora'] },
                { label: 'Rel. Edição de Evento', icon: 'account_balance', routerLink: ['relatorio/relatorio-edicao-de-evento'] },


                {label: 'Relatórios de Gestor', icon: 'dashboard', items: [
                        { label: 'Ativ. Aguard. Análise', icon: 'account_balance', routerLink: ['relatorio/relatorio-analise-por-atividade'] },
                        { label: 'Ativ. Em Análise', icon: 'account_balance', routerLink: ['relatorio/relatorio-em-analise-por-atividade'] },
                        { label: 'Ativ. Julg. Membro', icon: 'account_balance', routerLink: ['relatorio/relatorio-atividades-julgadas-membro-comissao'] }
                    ]
                }
            ]
        },
    ];
    
}




// WEBPACK FOOTER //
// ./src/app/entity/menu.model.ts